import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import s from './PopupOverlay.scss';
// Position can have [TOP RIGHT, CENTER, BOTTOM]
const PopupOverlay = ({
  children,
  enableClose = true,
  closeCallback,
  position,
  outSideClickHandler,
  outSideClickClose,
  blackOverlayEnabled = true,
  show = false,
  noGap = false,
  fixWidth = false,
  noBoxShadow = false,
  roundCross = false,
}) => {
  const [close, setClose] = useState(false);
  const [tobeShown, setTobeShown] = useState(false);
  const [tobeShownCSS, setTobeShownCSS] = useState(false);
  const popupRef = useRef(null);
  const handleClose = () => {
    setTobeShownCSS(false);
    if (blackOverlayEnabled) {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('disable-scroll');
    }
    setTimeout(() => {
      setClose(!close);
      if (closeCallback && typeof closeCallback === 'function') {
        closeCallback();
      }
      const popupOverlay = document.querySelector('.popupoverlay');
      if (popupOverlay) {
        popupOverlay.remove();
      }
    }, 1000);
  };

  const handleClickOutside = () => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      if (outSideClickHandler && typeof outSideClickHandler === 'function') {
        outSideClickHandler();
      }
      if (outSideClickClose) {
        handleClose();
      }
    }
  };

  const showPopup = () => {
    const popupOverlay = document.createElement('div');
    popupOverlay.classList.add('popupoverlay');
    document.body.appendChild(popupOverlay);
    if (blackOverlayEnabled) {
      document.getElementsByTagName('body')[0].classList.add('disable-scroll');
    }
    setTobeShown(true);
    setTimeout(() => {
      setTobeShownCSS(true);
    }, 100);

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  };

  useEffect(
    () => {
      if (show) {
        showPopup();
      }
    },
    [show],
  );

  return !close && tobeShown ? (
    <PopupPortal
      wrapper=".popupoverlay"
      usePopupPortal={typeof window !== 'undefined'}
    >
      <div
        className={`${s.popupOverlay} ${s[position]} ${noGap ? s.noGap : ''} ${
          noBoxShadow ? s.noBoxShadow : ''
        } ${roundCross ? s.roundCross : ''} ${fixWidth ? s.fixWidth : ''} ${tobeShownCSS ? s.show : ''}`}
      >
        {blackOverlayEnabled && <div className={s.blackOverLay} />}
        <div className={s.popupContent} ref={popupRef}>
          {enableClose && <span className={s.close} onClick={handleClose} />}
          {children}
        </div>
      </div>
    </PopupPortal>
  ) : null;
};

PopupOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  closeCallback: PropTypes.func.isRequired,
  noGap: PropTypes.bool,
  roundCross: PropTypes.bool,
  noBoxShadow: PropTypes.bool,
  fixWidth: PropTypes.bool,
};

PopupOverlay.defaultProps = {
  noGap: false,
  noBoxShadow: false,
  fixWidth: false,
  roundCross: false,
};

export default PopupOverlay;
